(function () {
  document.querySelectorAll('.testimonials').forEach(function (section) {
    const slider = section.querySelector('.testimonials__slider');
    const slides = section.querySelectorAll('.testimonials__slide');
    const prevBtn = section.querySelector('.testimonials__btn--prev');
    const nextBtn = section.querySelector('.testimonials__btn--next');

    if (slides.length < 2) {
      return;
    }

    let current = 0;
    const total = slides.length;

    function showSlide(n) {
      current = (n + total) % total;
      slider.scrollTo({ left: current * slider.offsetWidth, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      showSlide(current - 1);
    });

    nextBtn.addEventListener('click', function () {
      showSlide(current + 1);
    });
  });
})();
